// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__icCMw","transparent":"Button_transparent__1jtl0"};